import { FC } from "react";
import { Stepper } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { CheckIcon } from "../../../shared/svg/CheckIcon";
import "./AuthSteps.scss";
import { useTranslation } from "react-i18next";

interface Props {
  step: number;
}

export const AuthSteps: FC<Props> = ({ step }) => {
  const { t } = useTranslation();

  const matches = useMediaQuery("(max-width: 520px)");

  return (
    <Stepper
      completedIcon={<CheckIcon />}
      iconSize={matches ? 16 : 24}
      active={step}
      // onStepClick={onStepClick}
    >
      <Stepper.Step icon={<CheckIcon />} label={t("stepper.sign_up")} />
      <Stepper.Step icon={<CheckIcon />} label={t("stepper.upload_cv")} />
      <Stepper.Step
        icon={<CheckIcon />}
        label={t("stepper.answer_questions")}
      />
    </Stepper>
  );
};
